// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"dn-z","hideOnMobile":"en-z"};